import { AnyObject } from '@common/types/queryState';
import { isObject } from '@common/utils';

export function getDraftedValues<T extends object>(
    draftFields: AnyObject | boolean,
    allValues: T,
): Partial<T> {
    if (draftFields === true || !isObject(draftFields)) {
        return allValues as Partial<T>;
    }

    const draftedEntries = Object.entries(draftFields).flatMap(
        ([key, isDrafted]): Array<[string, unknown]> => {
            const currentValue = allValues[key as keyof T];

            if (isDrafted === true || Array.isArray(currentValue)) {
                return [[key, currentValue]];
            }

            if (isObject(isDrafted) && isObject(currentValue)) {
                const nestedDiff = getDraftedValues(
                    isDrafted,
                    currentValue as object,
                );

                if (Object.keys(nestedDiff).length > 0) {
                    return [[key, nestedDiff]];
                }
            }

            return [];
        },
    );

    return Object.fromEntries(draftedEntries) as Partial<T>;
}
